/**
 * API Configuration Utility
 * Centralizes backend URL configuration for all API calls
 */

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://nhhs-analytics-dev-production.up.railway.app';
if (process.env.REACT_APP_BACKEND_URL) {
  // React does not expose which .env file was used, but you can clarify in the log:
  console.log('[api.js] Using REACT_APP_BACKEND_URL from environment variable (set in .env.production for production builds, .env.local for local dev):', process.env.REACT_APP_BACKEND_URL);
} else {
  console.log('[api.js] Using fallback Railway URL:', API_BASE_URL);
}

/**
 * Creates a full API URL from a relative path
 * @param {string} path - Relative API path (e.g., '/api/projects')
 * @returns {string} - Full URL to the backend API
 */
export const apiUrl = (path) => {
  return `${API_BASE_URL.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
};

/**
 * Fetch wrapper that automatically uses the correct backend URL
 * Adds error handling and debug logging.
 */
export const apiFetch = async (path, options = {}) => {
  const url = apiUrl(path);
  console.log('[apiFetch] Fetching:', url, options);

  try {
    const res = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    });

    if (!res.ok) {
      const text = await res.text();
      console.error('[apiFetch] ❌ HTTP Error:', res.status, text);
      throw new Error(text || `HTTP ${res.status}`);
    }

    const data = await res.json();
    console.log('[apiFetch] ✅ Response:', data);
    return data;
  } catch (err) {
    console.error('[apiFetch] ❌ Network/Parsing Error:', err);
    throw err;
  }
};

export default { apiUrl, apiFetch };